import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.26",
  height: "19.26",
  viewBox: "0 0 19.26 19.26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  id: "Groupe_2595",
  transform: "translate(2223.048 -3555.237) rotate(45)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0,0H19.238",
    transform: "translate(946 4085.865)",
    fill: "none",
    stroke: "inherit",
    "stroke-linecap": "round",
    "stroke-width": "3"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0,0H18.979",
    transform: "translate(955.619 4095.354) rotate(-90)",
    fill: "none",
    stroke: "inherit",
    "stroke-linecap": "round",
    "stroke-width": "3"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}